import { createContext } from "react";

const RegularClassContext = createContext();

export default RegularClassContext;
